import { Check, ArrowRight, Eye, EyeOff } from "lucide-react";
import { Reveal } from "@/components/launchx/Reveal";
import { agencyWa } from "./AgencyLayout";

const inr = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const AgencyPackages = ({ content, scrollTo }) => {
  const show = content?.show_pricing;
  const packages = content?.packages || [];

  return (
    <section id="packages" data-testid="agency-packages" className="bg-background py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blue-600">Packages</p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            Simple packages, honest scope
          </h2>
          <p className="mt-4 text-base text-slate-600 max-w-2xl leading-relaxed">
            {show
              ? "Transparent pricing. Ad budgets are paid by you directly to Meta/Google — our fees cover strategy, setup and management."
              : "Every business is different, so we quote after understanding yours. Start with a free audit — you'll get a clear scope and price before paying anything."}
          </p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {packages.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <div data-testid={`agency-package-card-${p.id}`} className={`h-full rounded-3xl p-7 sm:p-8 flex flex-col transition-all duration-300 hover:-translate-y-1 ${i === 1 ? "bg-navy text-white border border-navy shadow-xl shadow-navy/20" : "bg-white border border-slate-200/80 shadow-sm hover:shadow-xl hover:border-electric/30"}`}>
                {i === 1 && <span className="self-start text-[10px] font-bold uppercase tracking-[0.2em] bg-cyanx text-navy rounded-full px-3 py-1">Most Popular</span>}
                <h3 className={`mt-4 font-display text-xl font-semibold ${i === 1 ? "text-white" : "text-slate-900"}`}>{p.name}</h3>
                {show ? (
                  <p className={`mt-3 font-display text-3xl font-extrabold ${i === 1 ? "text-cyanx" : "text-electric"}`} data-testid={`agency-package-price-${p.id}`}>
                    {inr(p.price)}<span className={`text-sm font-medium ${i === 1 ? "text-slate-400" : "text-slate-500"}`}> one-time</span>
                  </p>
                ) : (
                  <p className={`mt-3 flex items-center gap-2 text-sm font-semibold ${i === 1 ? "text-cyanx" : "text-electric"}`} data-testid={`agency-package-price-${p.id}`}>
                    <EyeOff size={14} /> Pricing on request
                  </p>
                )}
                <ul className="mt-6 space-y-3 flex-1">
                  {(p.features || []).map((f) => (
                    <li key={f} className={`flex items-start gap-2.5 text-sm ${i === 1 ? "text-slate-300" : "text-slate-700"}`}>
                      <Check size={15} className={`mt-0.5 shrink-0 ${i === 1 ? "text-cyanx" : "text-electric"}`} /> {f}
                    </li>
                  ))}
                </ul>
                <button data-testid={`agency-package-cta-${p.id}`} onClick={() => scrollTo("consultation")}
                  className={`mt-7 inline-flex items-center justify-center gap-2 text-sm font-semibold rounded-full px-6 py-3.5 transition-all ${i === 1 ? "bg-electric hover:bg-electric-dark text-white hover:shadow-lg hover:shadow-electric/40" : "bg-navy hover:bg-navy-800 text-white"}`}>
                  {show ? "Get Started" : "Get My Quote"} <ArrowRight size={15} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>

        {!show && (
          <Reveal delay={0.2}>
            <p className="mt-8 flex items-center justify-center gap-2 text-xs text-slate-500" data-testid="agency-packages-hidden-note">
              <Eye size={13} /> Final pricing depends on your scope — always shared in writing before any payment.
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
};
